// extracted by mini-css-extract-plugin
export default {"card":"I1-z","carouselContainer":"J1-z","carouselContent":"K1-z"};